import React from 'react';
import { LandingPage } from '../../LandingPage/LandingPage';
export const AccessDeniedLandingPage = () => (React.createElement(LandingPage, { title: "K.I.C.S. \u2014 Access Denied", content: "You do not have permission to access this application. Please contact the application owner to request access.", qaIdBase: "landingPageAccessDenied" }));
